import React, { useEffect, useState } from 'react';

function MyBookings() {
  const [myBookings, setMyBookings] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const currentUser = localStorage.getItem('currentUser');

  const getBookingID = (b) =>
    `${b.email}_${b.checkin}_${b.checkout}_${b.name}`.replace(/\s+/g, '');

  const getDismissed = () =>
    JSON.parse(localStorage.getItem(`user_dismissed_${currentUser}`)) || [];

  useEffect(() => {
    document.title = "Hotel Atlanta | My Bookings";

    const all = JSON.parse(localStorage.getItem('hotelBookings')) || [];
    const userBookings = all.filter(b => b.email === currentUser);
    setMyBookings(userBookings);

    const dismissed = getDismissed();
    const unalertedAdminCancels = userBookings.filter(b => {
      const id = getBookingID(b);
      return (
        b.status === 'Canceled by Admin' &&
        !dismissed.includes(id) &&
        localStorage.getItem(`alerted_${id}`) !== 'true'
      );
    });

    if (unalertedAdminCancels.length > 0) {
      setShowPopup(true);
      unalertedAdminCancels.forEach(b =>
        localStorage.setItem(`alerted_${getBookingID(b)}`, 'true')
      );
    }
  }, [currentUser]);

  const updateBookings = (list) => {
    localStorage.setItem('hotelBookings', JSON.stringify(list));
    const filtered = list.filter(b => b.email === currentUser);
    setMyBookings(filtered);
  };

  const handleCancel = (target) => {
    const all = JSON.parse(localStorage.getItem('hotelBookings')) || [];
    const updated = all.map(b =>
      getBookingID(b) === getBookingID(target)
        ? { ...b, status: 'Canceled by User' }
        : b
    );
    updateBookings(updated);
  };

  const handleDelete = (target) => {
    const dismissed = getDismissed();
    localStorage.setItem(
      `user_dismissed_${currentUser}`,
      JSON.stringify([...dismissed, getBookingID(target)])
    );
    setMyBookings(prev =>
      prev.filter(b => getBookingID(b) !== getBookingID(target))
    );
  };

  const visibleBookings = myBookings.filter(
    b => !getDismissed().includes(getBookingID(b))
  );

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: 'auto' }}>
      <h2 style={{ textAlign: 'center', marginBottom: 20 }}>My Bookings</h2>

      {showPopup && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <p style={{ fontWeight: 'bold', color: '#900', marginBottom: '10px' }}>
              ⚠️ One or more of your bookings were canceled by admin.
            </p>
            <button
              onClick={() => setShowPopup(false)}
              style={btn('#900')}
            >
              Okay
            </button>
          </div>
        </div>
      )}

      {visibleBookings.length === 0 ? (
        <p style={{ textAlign: 'center' }}>You have not made any bookings yet. Please make a reservation!</p>
      ) : (
        <div style={{ display: 'grid', gap: '20px' }}>
          {visibleBookings.map((b, index) => {
            const isCanceled = b.status?.includes('Canceled');
            return (
              <div key={index} style={{
                border: '1px solid #ccc',
                padding: '20px',
                borderRadius: '8px',
                backgroundColor: isCanceled ? '#fff5f5' : '#f9f9f9'
              }}>
                <p><strong>Name:</strong> {b.name}</p>
                <p><strong>Email:</strong> {b.email}</p>
                <p><strong>Check-In:</strong> {b.checkin}</p>
                <p><strong>Check-Out:</strong> {b.checkout}</p>
                <p><strong>Room:</strong> {b.roomLabel}</p>
                <p><strong>Payment:</strong> {b.payment}</p>
                <p><strong>Status:</strong> {b.status || "Confirmed"}</p>

                {!isCanceled ? (
                  <button onClick={() => handleCancel(b)} style={btn('#f44336')}>
                    Cancel Booking
                  </button>
                ) : (
                  <button onClick={() => handleDelete(b)} style={btn('#888')}>
                    Delete
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const btn = (color) => ({
  marginTop: '10px',
  backgroundColor: color,
  color: '#fff',
  border: 'none',
  padding: '8px 12px',
  borderRadius: '4px',
  cursor: 'pointer'
});

const modalOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999
};

const modalContent = {
  backgroundColor: '#fff',
  padding: '30px',
  borderRadius: '10px',
  boxShadow: '0 0 15px rgba(0,0,0,0.2)',
  textAlign: 'center',
  minWidth: '300px'
};

export default MyBookings;